export const category = {
    labels: {
        name: "Name",
        categories: "Categories",
        category: "Category",
        description: "Description",
        add_category: "Add Category",
        delete_category: "Delete Category",
    },
    placeholders: {
        name: "Category name",
        description: "Category description",
    },
    modals: {
        titles: {
            add_category: "Add Category",
        },
        messages: {
        },
    },
    texts: {
        delete_category: "Are you sure you want to delete this category?<br/>All services in this category will be deleted.",
    },
};
